<div class="popup-container tlms-popup">
    <header>
        <div class="header" style="display:block">T&E Number : {{tenumber}}</div>
        <button class="close" style="top:-3px" (click)="close()">
            <mat-icon>close</mat-icon>
        </button>
    </header>
    <ng-container>
        <div style="padding: 16px 24px 16px 24px;">
            <div class="col-12" style="width: 100%;">
                <div class="body">
                    <mat-tab-group (selectedTabChange)="tabChange($event)">
                        <mat-tab label="Assigned"></mat-tab>
                        <mat-tab label="Unassigned"></mat-tab>
                    </mat-tab-group>
                    <ag-grid-angular [enableCellTextSelection]="true" #AssignGrid style="width:100%;height:368px;"
                        id="LIOS-GRID" class="ag-theme-balham" (gridReady)="onGridReady($event);"
                        (window:resize)="sizeToFit()" [animateRows]="true" [getRowHeight]="getRowHeight"
                        [defaultColDef]="defaultColDef" [columnDefs]="columnDefs" [rowData]="displayRowData"
                        [context]="context" [icons]="icons">
                    </ag-grid-angular>
                </div>
                <label *ngIf="errormsg" class="errormsg"> {{errormsg}} </label>
            </div>
        </div>
        <div class="cfooter d-flex justify-content-between align-items-center popup-footer">
            <button (click)="onNoClick()" class="mCancel"> CANCEL
            </button>
            <button class="black-btn" style="display: inline" (click)="saveClick()">
                {{positiveButtonLabel}}
            </button>
        </div>
    </ng-container>
</div>